import logo from './logo.svg';
import './App.css';
import GolangDeployOnePage from "./components/GolangDeployOnePage";

function App() {
   return <GolangDeployOnePage />;
}

export default App;
